/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SendTestNotificationRequest
 */
export interface SendTestNotificationRequest {
  /**
   *
   * @type {string}
   * @memberof SendTestNotificationRequest
   */
  mobileDeviceId: string;
  /**
   *
   * @type {string}
   * @memberof SendTestNotificationRequest
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof SendTestNotificationRequest
   */
  body: string;
}

/**
 * Check if a given object implements the SendTestNotificationRequest interface.
 */
export function instanceOfSendTestNotificationRequest(
  value: object,
): value is SendTestNotificationRequest {
  if (!("mobileDeviceId" in value) || value["mobileDeviceId"] === undefined)
    return false;
  if (!("title" in value) || value["title"] === undefined) return false;
  if (!("body" in value) || value["body"] === undefined) return false;
  return true;
}

export function SendTestNotificationRequestFromJSON(
  json: any,
): SendTestNotificationRequest {
  return SendTestNotificationRequestFromJSONTyped(json, false);
}

export function SendTestNotificationRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SendTestNotificationRequest {
  if (json == null) {
    return json;
  }
  return {
    mobileDeviceId: json["mobileDeviceId"],
    title: json["title"],
    body: json["body"],
  };
}

export function SendTestNotificationRequestToJSON(
  json: any,
): SendTestNotificationRequest {
  return SendTestNotificationRequestToJSONTyped(json, false);
}

export function SendTestNotificationRequestToJSONTyped(
  value?: SendTestNotificationRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    mobileDeviceId: value["mobileDeviceId"],
    title: value["title"],
    body: value["body"],
  };
}
